<div class="pnl-settings-data-import">
  <header>
    <a [routerLink]="['/app/configuracao']" class="back">Configurações</a>
    <h1>Importação de dados</h1>
  </header>

  <form [formGroup]="settingsFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div *ngIf="files.length > 0" class="mb20">
        <strong>Arquivos enviados</strong>
        <div class="table-content">
          <div class="table">
            <div class="header">
              <span class="f2">Nome do arquivo</span>
              <span class="f2">Enviado em</span>
              <span class="f2">Processamento em</span>
              <span>Produtos</span>
              <span class="center">Erros</span>
              <span class="center">Status</span>
            </div>
            <div *ngFor="let f of files; let i = index" class="row">
              <span class="f2">{{ f.name_file }}</span>
              <span *ngIf="f.dt_created" class="f2">{{
                f.dt_created.replace(" ", "T") | date: "d/MM/y H:mm"
              }}</span>
              <span *ngIf="!f.dt_created" class="f2"></span>
              <span *ngIf="f.dt_finished" class="f2">{{
                f.dt_finished.replace(" ", "T") | date: "d/MM/y H:mm"
              }}</span>
              <span *ngIf="!f.dt_finished" class="f2"></span>
              <span
                >{{ f.total }} total<br />{{ f.adds }} novos<br />{{
                  f.updates
                }}
                atualizados</span
              >
              <span class="center">{{ f.errors }}</span>
              <span class="center">
                <b *ngIf="f.status == 'E'" class="error">Erro</b>
                <b *ngIf="f.status == 'W'" class="aguardando">Na fila</b>
                <b *ngIf="f.status == 'P'" class="processando">Processando</b>
                <b *ngIf="f.status == 'F'" class="finalizado">Importado</b>
              </span>
            </div>
          </div>
        </div>
      </div>
      <app-import-file
        (onChangeEvent)="onChangeImport($event)"
        (onSuccessEvent)="onSuccessImport($event)"
      ></app-import-file>
    </section>
  </form>

  <div class="actions" [class.dflex]="changed">
    <div>
      <button type="button" (click)="onSubmit()" class="btn btn-primary">
        <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
        Enviar arquivo
      </button>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
